module.exports = __webpack_public_path__ + "b53feeefca33136429f2780e92fae57a.svg";